import Storage from "../storage";

export const activate = (id)=>{
	Storage.dispatch({
		type : 'ACTIVATE',
		id : id
	});
}

export const activateNewGloop = (id) =>{
	Storage.dispatch({
		type : 'NEW GLOOP',
		id : id,
	});
}
export const activateNewGloopStatic = (id) =>{
	Storage.dispatch({
		type : 'NEW GLOOP',
		id : id,
	});
}

export const deactivate = ()=>{
	window.jQuery('body').css({position : 'static'});
	Storage.dispatch({
		type : 'DEACTIVATE'
	});
}

export const setScreen = (screen='gloop') => {
	Storage.dispatch({
		type : 'SET SCREEN',
		data : screen
	});
}

export const saveGloop = ()=>{
	Storage.dispatch({
		type : 'SAVE'
	})
}


window.activateGloop = activate;
window.activateNewGloop = activateNewGloop;
window.activateNewGloopStatic = activateNewGloopStatic;
